import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
Vue.use(Router);
import Store from "@/store/store.js";
const store = Store;

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: '/',
      redirect: '/authentication/SignIn'
    },

    {
      name: "SignIn",
      path: "/authentication/SignIn/:token?",
      component: () => import("@/views/ched_dashboards/authentication/SignIn"),
      meta: {
        permission: 'guest'
      }
    },

    {
      name: "SignUp",
      path: "/authentication/SignUp",
      component: () => import("@/views/ched_dashboards/authentication/SignUp"),
      meta: {
        permission: 'guest'
      }
    },

    {
      name: "CompleteSignUp",
      path: "/authentication/CompleteSignUp",
      component: () => import("@/views/ched_dashboards/authentication/CompleteSignUp"),
      meta: {
        permission: 'guest'
      }
    },

    {
      name: "PendingAccount",
      path: "/authentication/PendingAccount",
      component: () => import("@/views/ched_dashboards/authentication/PendingAccount"),
      meta: {
        permission: 'guest'
      }
    },

    {
      name: "DisapprovedAccount",
      path: "/authentication/DisapprovedAccount",
      component: () => import("@/views/ched_dashboards/authentication/DisapprovedAccount"),
      meta: {
        permission: 'guest'
      }
    },

    {
      name: "DeactivatedAccount",
      path: "/authentication/DeactivatedAccount",
      component: () => import("@/views/ched_dashboards/authentication/DeactivatedAccount"),
      meta: {
        permission: 'guest'
      }
    },


    {
      // scholarship/grantees/tdp
      path: "/admin",
      component: () => import("@/views/ched_dashboards/admin_app/layout/Layout"),
      name: 'mainAdminApp',
      children: [     
        {
          name: "ElPrDashboard",
          path: "dashboard/elpr",
          component: () => import("@/views/ched_dashboards/HEI-ElPr"),
        },
        // {
        //   name: "BillingDashboard",
        //   path: "dashboard/billing",
        //   component: () => import("@/views/ched_dashboards/HEI-Billing"),
        // },
        // {
        //   name: "BillingGranteeList",
        //   path: "scholarship/billing/:hei_uii/:hei_name",
        //   component: () => import("@/views/ched_dashboards/HEI-Billing-Grantee-List"),
        // },
        {
          name: "STUFAPSDashboards",
          path: "dashboard/stufaps",
          component: () => import("@/views/ched_dashboards/admin_app/dashboards/stufaps/StuFAPsDashboardMain"),
        },
        {
          name: "TESDashboards",
          path: "dashboard/:grant_type",
          component: () => import("@/views/ched_dashboards/admin_app/dashboards/unifast/TESDashboardMain"),
        },
        {
          name: "LiquidationDashboard",
          path: "dashboard/liquidation",
          component: () => import("@/views/ched_dashboards/HEI-Liquidation"),
        },
        {
          name: "CspStufaps",
          path: "dashboard/Csp-Stufaps/scholars",
          component: () => import("@/views/ched_dashboards/Csp-Stufaps"),
        },
        {
          name: "Tes",
          path: "dashboard/TES/grantees",
          component: () => import("@/views/ched_dashboards/Tes"),
        },
        {
          name: "TdpTes",
          path: "dashboard/Tdp-Tes/grantees",
          component: () => import("@/views/ched_dashboards/Tdp-Tes"),
        },
        {
          name: "UserAccount&Profile",
          path: "user/account&profile",
          component: () => import("@/views/ched_dashboards/account_profile/AccountProfile"),
        },


        /** Accounting Starts */
        {
          name: "Accounting",
          path: "accounting/:grant_type",
          component: () => import("@/views/ched_dashboards/accounting/Accounting"),
        },
        {
          name: "AccountingGranteeList",
          path: "scholarship/accounting/:hei_uii/:hei_name",
          component: () => import("@/views/ched_dashboards/accounting/sub-components/GranteesList"),
        },
        /** Accounting Ends */

        /** Grantees Starts */
        {
          name: "GranteesList",
          path: "scholarship/grantees/:grant_type",
          component: () => import("@/views/ched_dashboards/grantees/sub-components/GranteesList"),
        },
        /** Grantees Ends */


        /** Billing Starts */
        {
          name: "AdminTES3BMain",
          path: "scholarship/billing/testhreebsujfqgixlf",
          component: () => import("@/views/ched_dashboards/billing/tes_3b/BillingTes3BMain"),
        },
        {
          name: "AdminTES3B_BillingDetails",
          path: "scholarship/billing/tes-3b_details/:ref_number?/:year_of_examination?",
          component: () => import("@/views/ched_dashboards/billing/tes_3b//BillingTes3BDetails.vue"),
        },
        {
          name: "BillingSummaryPerHEIList",
          path: "scholarship/billing/:grant_type",
          component: () => import("@/views/ched_dashboards/billing/hei/Billing"),
        },
        {
          name: "BillingGranteesList",
          path: "scholarship/billing/:hei_uii/:hei_name",
          component: () => import("@/views/ched_dashboards/billing/sub-components/GranteesList"),
        },

        /** Billing Ends */

        /** Validation Starts */
        {
          name: "ValidationHEIList",
          path: "scholarship/validation/:grant_type",
          component: () => import("@/views/ched_dashboards/validation/hei/Validation"),
        },
        {
          name: "ValidationHEIListForStufaps",
          path: "scholarship/stufaps_validation/:grant_type?",
          component: () => import("@/views/ched_dashboards/admin_app/validation/ValidationMainComponent"),
        },
        {
          name: "ValidationGranteeList",
          path: "scholarship/validation/:scholarship_type/:hei_uii/:hei_name",
          component: () => import("@/views/ched_dashboards/validation/sub-components/GranteesList"),
        },
        {
          name: "ValidationScholarsList",
          path: "scholarship/validation/scholars/list",
          component: () => import("@/views/ched_dashboards/admin_app/validation/GenericValidationScholarsList"),
        },
        {
          name: "CMSPValidationScholarsList",
          path: "scholarship/validation/cmsp_scholars/list",
          component: () => import("@/views/ched_dashboards/admin_app/validation/ChedMeritScholarship"),
        },
        {
          name: "ScholarsListStuFAPs",
          path: "scholars/list/stufaps",
          component: () => import("@/views/ched_dashboards/admin_app/all_scholarships/OtherScholarships"),
        },
        {
          name: "ScholarsListCMSP",
          path: "scholars/list/cmsp",
          component: () => import("@/views/ched_dashboards/admin_app/all_scholarships/ChedMeritScholarship"),
        },
        /** Validation Ends */


        /** Management Starts */
        {
          name: "AdminUser",
          path: "accounts",
          component: () => import("@/views/ched_dashboards/admin_accounts/AdminAccounts"),
        },
        {
          name: "UserAccounts",
          path: "hei/accounts",
          component: () => import("@/views/ched_dashboards/hei_focals/UserAccounts"),
        },
        {
          name: "Heis",
          path: "heis",
          component: () => import("@/views/ched_dashboards/heis/Heis"),
        },

        /** Management Ends */
      ],
      meta: {
        permission: 'admin-user-auth',
      }
    },

    {
      name: 'mainHeiApp',
      path: "/hei/app",
      component: () => import("@/views/ched_dashboards/hei_app/layout/Layout"),
      children: [
        {
          name: "HEIUserAccount&Profile",
          path: "user/account/profile",
          component: () => import("@/views/ched_dashboards/hei_app/account_profile/AccountProfile"),
        },
        {
          name: "TES3B_Billing",
          path: "billing/testhreeb",
          component: () => import("@/views/ched_dashboards/hei_app/components/BillingTes3B.vue"),
        },
        {
          name: "TES3B_BillingDetails",
          path: "billing/tes-3b_details/:ref_number?/:year_of_graduation?",
          component: () => import("@/views/ched_dashboards/hei_app/components/BillingTes3BDetails.vue"),
        },
        {
          name: "TES Billing",
          path: "billing/tes",
          component: () => import("@/views/ched_dashboards/hei_app/components/billings/TES/TES.vue"),
        },
        {
          name: "TES Billing Details",
          path: "billing/tes/tes/details/:id?/:reference_number?",
          component: () => import("@/views/ched_dashboards/hei_app/components/billings/TES/TESBillingDetails.vue"),
        },
        {
          name: "TES Grantees",
          path: "billing/tesgrantees",
          component: () => import("@/views/ched_dashboards/hei_app/components/billings/TES/TESBillingAllGrantees.vue"),
        },
        {
          name: "All TDP-TES Grantees",
          path: "billing/tdpgrantees",
          component: () => import("@/views/ched_dashboards/hei_app/components/billings/TES/TDPTESBillingAllGrantees.vue"),
        },
        {
          name: "ProfileManagement",
          path: "profile/management",
          component: () => import("@/views/ched_dashboards/hei_app/components/ProfileAndSignatory.vue"),
        },

        {
          name: "CMSP_Scholars",
          path: "cmspmanagement",
          component: () => import("@/views/ched_dashboards/hei_app/components/ChedMeritScholarship.vue"),
        },
        {
          name: "ForValidation",
          path: "forvalidation",
          component: () => import("@/views/ched_dashboards/hei_app/components/ForValidation.vue"),
        },
      ],

      meta: {
        permission: 'hei-user-auth'
      }
    },


    /**
     ** StuFAPs Management
     */
    // {
    //   name: 'mainHeiApp',
    //   path: "/hei",
    //   component: () => import("@/views/ched_dashboards/hei_app/layout/Layout"),
    //   children: [
    //     {
    //       name: "CMSP_Scholars",
    //       path: "app/cmspmanagement",
    //       component: () => import("@/views/ched_dashboards/hei_app/components/ChedMeritScholarship.vue"),
    //     },
    //     {
    //       name: 'ModuleUnderDevelopment',
    //       path: "underdevelopment",
    //       component: () => import("@/views/ched_dashboards/errors/UnderDevelopment"),
    //     }
    //   ],

    //   meta: {
    //     permission: 'hei-user-auth'
    //   }
    // },
    /**
     ** StuFAPs Management End
     */




    {
      name: 'mainHeiRegistrarApp',
      path: "/hei/app/registrar",
      component: () => import("@/views/ched_dashboards/hei_app/layout/Layout"),
      children: [
        {
          name: "ELPRSubmissionDashboard",
          path: "submission/dashboard",
          component: () => import("@/views/ched_dashboards/hei_app/components/dashboards/ELPR/MainDashboard"),
        },
      ],

      meta: {
        permission: 'hei-user-auth'
      }
    },

    {
      path: "/hei/dashboards/stufaps",
      component: () => import("@/views/ched_dashboards/hei_app/layout/Layout"),
      children: [
        /***
         ** Dashboards
         */
         {
          name: "StuFAPsDashboard",
          path: "cmsp",
          component: () => import("@/views/ched_dashboards/hei_app/components/dashboards/StuFAPs/StuFAPsDashboardMain.vue"),
        },
      ],

      meta: {
        permission: 'hei-user-auth'
      }
    },

    // {
    //   path: "/hei/app/billings/stufaps",
    //   component: () => import("@/views/ched_dashboards/hei_app/layout/Layout"),
    //   children: [
    //     /**
    //      ** Billings
    //      */
    //     {
    //       name: "CMSP_Scholars_Billing",
    //       path: "cmsp",
    //       component: () => import("@/views/ched_dashboards/hei_app/components/billings/CMSP/MainBillingList.vue"),
    //     },
    //     {
    //       name: "CMSP_Scholars_Billing_Details",
    //       path: "cmsp/details/:id/:reference_number",
    //       component: () => import("@/views/ched_dashboards/hei_app/components/billings/CMSP/ChedMeritScholarship.vue"),
    //     },
    //     /**
    //      ** Billing Ends
    //      */
    //   ],

    //   meta: {
    //     permission: 'hei-user-auth'
    //   }
    // },

    {
      path: "/error",
      component: () => import("@/views/ched_dashboards/errors/UnauthorizedError"),
    },

    {
      name: "AccountNotFound",
      path: "/authentication/AccountDoesntExistError/:email?",
      component: () => import("@/views/ched_dashboards/authentication/AccountNotFound"),
    },


    {
      path: "*",
      component: () => import("@/views/ched_dashboards/errors/Error"),
    },
  ],
});

import NProgress from "nprogress";
import { replace } from "lodash";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }

  let IS_AUTHENTICATED = store.getters.isAuthenticated;
  let USER_PROFILE     = store.getters.getUserProfile;
  let GUARD_NAME       = (USER_PROFILE && USER_PROFILE.roles && USER_PROFILE.roles.length > 0) ? USER_PROFILE.roles[0].guard_name : null;
  let ACCOUNT_STATUS   = (USER_PROFILE && USER_PROFILE.account_status) ? USER_PROFILE.account_status.account_status : null;


  if(IS_AUTHENTICATED){
    if(GUARD_NAME && GUARD_NAME === 'api'){
      if(['pending', 'deactivated', 'disapproved'].includes(ACCOUNT_STATUS.toLowerCase())){
          if(ACCOUNT_STATUS.toLowerCase() === 'pending' && to.name != 'PendingAccount'){
            next({ name: 'PendingAccount' });
          }
          else if(ACCOUNT_STATUS.toLowerCase() === 'deactivated'){
            next({ name: 'DeactivatedAccount' });
          }
          else if(ACCOUNT_STATUS.toLowerCase() === 'disapproved'){
            next({ name: 'DisapprovedAccount' });
          }
          else if(to.path === "/authentication/SignIn" || to.matched.some(record => record.meta.permission === "admin-user-auth")){
            next({ name: "mainHeiApp" });
          }
          else{
            next();
          }
      }

      else{
        if(to.path === "/authentication/SignIn" 
          || to.matched.some(record => record.meta.permission === "admin-user-auth")
          || to.matched.some(record => record.meta.permission === "guest")
          ){
          next({ name: "mainHeiApp" });
        }
        else if(to.name === 'mainHeiApp'){
          import('@/store/userRoles').then((res) => {
            console.log(res.isSTUFAPSCoordinator());
            if(res.isSTUFAPSCoordinator()){
              next({ name: "StuFAPsDashboard" })
            }
            // else if(res.isUNIFASTCoordinator()){
            //   next({ name: "TESDashboards" })
            // }
            else{
              next();
            }
          })
        }
        else{
          next();
        }
      }

    }

    else if(USER_PROFILE.user_type === 'admin'){
      if(to.path === "/authentication/SignIn"){
        next({ name: "mainAdminApp" });
      }
      else if(to.name === 'mainAdminApp'){
        import('@/store/userRoles').then((res) => {
          if(res.isSTUFAPSCoordinator()){
            next({ name: "STUFAPSDashboards" })
          }
          else if(res.areAllUNIFAST()){
            next({ name: "TESDashboards" })
          }
          else{
            next();
          }
        })
      }
      else{
        if(to.matched.some(record => record.meta.permission === "hei-user-auth")){
          next({ name: "mainAdminApp" });
        }
        else{
          next();
        }

        next();
      }
    }

    else{
      next();
    }

  }
  else{
    if(to.matched.some(record => record.meta.permission === "hei-user-auth")){
      next('/');
    }
    else if(to.matched.some(record => record.meta.permission === "admin-user-auth")){
      next('/');
    }
    else{
      next();
    }
    next();
  }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
